import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { User } from "../users.type";
import { toast } from "sonner";
import { useUpdateUser } from "../hooks/use-users";

type BlockUserModalProps = {
  user: User;
  onRefetch?: () => void;
};

export const BlockUserModal = ({ user, onRefetch }: BlockUserModalProps) => {
  const { updateUser, loading, error } = useUpdateUser(user.id);
  const handleDeleteUser = async () => {
    try {
      await updateUser({ id: user.id, blocked: !user.blocked, roles: user.roles });
      if (user.blocked) {
        toast.success("L'utilisateur a été mis à jour avec succès", {
          style: { color: "#228B22" },
        });
      } else {
        toast.success("L'utilisateur a été créé avec succès", {
          style: { color: "#228B22" },
        });
      }
      onRefetch?.();
    } catch {
      if (error) {
        toast.error(error.message || "Échec de la mise à jour de l'utilisateur");
      } else {
        toast.error("Une erreur s'est produite");
      }
    }
  };

  const title = user.blocked ? "Débloquer" : "Bloquer";

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          className="cursor-pointer bg-transparent border-none p-0 text-red-600"
          onClick={(e) => {
            e.stopPropagation();
          }}
          type="button"
        >
          {title}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title + " un utilisateur"}</AlertDialogTitle>
          <AlertDialogDescription>
            Êtes-vous sûr de vouloir {title.toLowerCase()} cet utilisateur ? Cette action est irréversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          {loading ? (
            <Button variant="default" disabled>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              En cours...
            </Button>
          ) : (
            <AlertDialogAction onClick={handleDeleteUser}>{title}</AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
